/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import CONFIG from '../config';

export const authenticationService = {
    login(username, password) {
        return axios.post(`${CONFIG.API_ROOT}/authentication/rest-auth/login/`, { username, password });
    },
    logout() {
        return axios.post(`${CONFIG.API_ROOT}/authentication/rest-auth/logout/`);
    },
    register({
        email, password1, password2, phone,
    }) {
        return axios.post(`${CONFIG.API_ROOT}/authentication/rest-auth/registration/`, {
            username: email,
            email,
            password1,
            password2,
            phone,
        });
    },
    recover(email) {
        return axios.post(`${CONFIG.API_ROOT}/authentication/password_reset/`, { email });
    },
    reset_password(newPassword, token) {
        return axios.post(`${CONFIG.API_ROOT}/authentication/password_reset/confirm/`, { password: newPassword, token });
    },
};
